import { s3Download } from "../util";
import { useAuth } from "./useAuth";

const useS3Download = () => {
	const { token } = useAuth();
	return (dir, id, name, type) => s3Download(dir, id, name, type, token);
};

export default useS3Download;
